// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__311D8","notes":"Notes_notes__3nPjQ"};